const sentryDsn = process.env.SENTRY_DSN
const allowedEnvironments = ['staging', 'production']
const railsEnv = process.env.RAILS_ENV
const hasValidSentryDsn = typeof sentryDsn === 'string' && sentryDsn.trim().length > 0
const isSentryEnabled = hasValidSentryDsn && allowedEnvironments.includes(railsEnv)

if (isSentryEnabled) {
  import('@sentry/browser').then(Sentry => {
    Sentry.init({
      dsn: sentryDsn,
      environment: railsEnv,
      release: process.env.SENTRY_RELEASE,
      // v11 defaults to inferring/storing the visitor's IP address (dataCollection.userInfo
      // defaults to true, replacing v10's sendDefaultPii: false default). Keep the old,
      // privacy-safe default.
      dataCollection: { userInfo: false },
      ignoreErrors: [
        // Google Maps internal minified errors (not actionable)
        /^[A-Z][a-z]$/,
        // Google Maps Places deprecation (warning only, not an error)
        /google\.maps\.places\.Autocomplete is not available/,
        // Safari throws this when third-party scripts (e.g. hcaptcha) try to
        // write to a non-configurable browser property. Not actionable.
        /Attempted to assign to readonly property/,
      ],
      beforeSend (event) {
        // Drop errors originating from Google Maps scripts (covers "Could not load",
        // "Load failed" from Maps fetch, and other internal Maps errors)
        const frames = event.exception?.values?.[0]?.stacktrace?.frames || []
        if (frames.some(f => f.filename?.includes('maps.googleapis.com'))) return null
        return event
      }
    })
  }).catch(err => {
    if (railsEnv !== 'production') {
      console.warn('Sentry failed to load:', err)
    }
  })
}
